module.exports = "/images/ico-mybenefit-vector-logo.svg?258227f9d547082a5869277aa5bbe9e3";